import authService from './auth.service';

export type AlertSeverity = 'high' | 'medium' | 'low';

export interface ConfigAlert {
  severity: AlertSeverity;
  area: string;
  code: string;
  title: string;
  detail: string;
}

export interface ConfigHealth {
  alerts: ConfigAlert[];
  checks_run: number;
}

class ConfigHealthService {
  /** Run the super-admin configuration health checks and return any alerts. */
  async get(): Promise<ConfigHealth> {
    const res = await authService.getApi().get<ConfigHealth>('/api/v1/admin/config-health');
    return res.data;
  }
}

export default new ConfigHealthService();
